import React, { forwardRef, useEffect, useState } from "react";
import showPass from "../../assets/img/showPass.svg";
import "./styles/text_input.css";

// import checkmark_circle from '../../images/checkmark-circle.svg'

const TextInput = forwardRef((props, ref) => {
  const [disabled, setDisabled] = useState(false);
  const [required, setRequired] = useState(false);
  const [activePass, setActivePass] = useState(false);

  useEffect(() => {
    if (props.disabled !== undefined && props.disabled !== null) {
      setDisabled(props.disabled);
    }
    if (props.required !== undefined && props.required !== null) {
      setRequired(props.required);
    }
  }, [props.disabled, props.required]);

  return (
    <div
      style={props.margin ? { margin: props.margin } : null}
      className={`input_component ${
        props.wrapper_margin ?? "input_component_unset_margin"
      }`}
    >
      {props.title ? (
        <span
          className={
            props.loginInput
              ? "input_component_title_new"
              : props.prospectsInput
              ? "prospects_input_title"
              : props.targetingInput
              ? "targeting_input_title"
              : ""
          }
        >
          {props.title}{" "}
          {props.subtitle ? (
            <span className={`input_component_subtitle`}>{props.subtitle}</span>
          ) : null}
        </span>
      ) : null}
      <label className={props.className ? props.className : null}>
        <input
          style={
            props.showPass
              ? { padding: "12px 52px 12px 8px" }
              : props.style
              ? props.style
              : props.width
              ? { width: `${props.width}` }
              : null
          }
          disabled={disabled}
          ref={ref}
          required={required}
          autoComplete={props.autoComplete}
          autoFocus={props.autoFocus}
          id={props.id ? props.id : null}
          maxLength={props.maxLength ?? 80}
          name={props.name ? props.name : ""}
          placeholder={props.placeholder ?? null}
          className={
            props.successInput
              ? "success_input custom_input"
              : props.wrongInput
              ? "wrong_input custom_input"
              : props.error
              ? `error custom_input ${
                  props.loginInput ? "login_input_error login_input" : ""
                } ${
                  props.prospectsInput
                    ? "prospects_input_error prospects_input"
                    : ""
                } ${
                  props.targetingInput
                    ? "targeting_input_error targeting_input"
                    : ""
                }`
              : `custom_input ${props.loginInput ? "login_input" : ""} ${
                  props.prospectsInput ? "prospects_input" : ""
                } ${props.targetingInput ? "targeting_input" : ""}`
          }
          type={activePass ? "text" : props.type ? props.type : "text"}
          value={props.value ? props.value : ""}
          onChange={
            props.onChange
              ? (e) => {
                  props.onChange(e);
                }
              : null
          }
        />
        {props.searchPages ? (
          props.searchPages
        ) : props.searchIcon ? (
          <svg
            className={"search_icon show_pass_icon"}
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17Z'
              stroke='#94A3B8'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M21 21L15 15'
              stroke='#94A3B8'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        ) : null}
        {props.showPass ? (
          props.newShowPassIcon ? (
            activePass ? (
              <svg
                onClick={() => setActivePass(!activePass)}
                className={"show_pass_icon"}
                width='20'
                height='20'
                viewBox='0 0 20 20'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  fillRule='evenodd'
                  clipRule='evenodd'
                  d='M4.16205 1.44639C3.90258 1.12202 3.42927 1.06941 3.1049 1.32888C2.78052 1.58836 2.72791 2.06166 2.98738 2.38604L5.14054 5.07775C5.14045 5.0778 5.14064 5.07769 5.14054 5.07775L5.97641 6.12321C5.97651 6.12315 5.97631 6.12326 5.97641 6.12321L7.00856 7.41298C7.00848 7.41307 7.00863 7.4129 7.00856 7.41298L7.85281 8.46894C7.85288 8.46884 7.85275 8.46903 7.85281 8.46894L11.0225 12.4308C11.0226 12.4308 11.0224 12.4309 11.0225 12.4308L11.8668 13.4869C11.8667 13.4869 11.8669 13.4868 11.8668 13.4869L12.6902 14.5157C12.6903 14.5156 12.6901 14.5157 12.6902 14.5157L13.5494 15.5903C13.5493 15.5903 13.5495 15.5903 13.5494 15.5903L15.3678 17.863C15.6272 18.1874 16.1006 18.24 16.4249 17.9805C16.7493 17.721 16.8019 17.2477 16.5424 16.9234L4.16205 1.44639ZM0.126914 9.6105C0.232515 9.46603 1.76606 7.39749 4.12704 5.73232L4.9563 6.76899C3.29771 7.92788 2.04874 9.3313 1.49922 9.99929C2.52606 11.2448 5.99486 15.0547 9.9999 15.0547C10.4945 15.0547 10.9807 14.9969 11.455 14.8931L12.359 16.0233C11.6058 16.244 10.8161 16.3734 9.9999 16.3734C4.56274 16.3734 0.305391 10.6332 0.126914 10.3887C-0.0423048 10.1569 -0.0423048 9.84238 0.126914 9.6105ZM6.04297 10.0001C6.04297 9.46865 6.14833 8.96129 6.33927 8.49787L7.37023 9.7867C7.36457 9.85711 7.36168 9.9283 7.36168 10.0001C7.36168 11.3292 8.34982 12.4318 9.63008 12.6118L10.6612 13.9008C10.4458 13.9372 10.2246 13.9562 9.99902 13.9562C7.8177 13.9562 6.04297 12.1815 6.04297 10.0001ZM13.6867 11.4328L12.6338 10.1166C12.6355 10.078 12.6364 10.0392 12.6364 10.0001C12.6364 8.70442 11.6972 7.62397 10.4638 7.4038L9.411 6.08769C9.6029 6.05897 9.79926 6.04408 9.99902 6.04408C12.1804 6.04408 13.9551 7.81881 13.9551 10.0001C13.9551 10.5052 13.86 10.9884 13.6867 11.4328ZM9.9999 4.94479C9.52938 4.94479 9.06645 4.99712 8.61414 5.09152L7.70672 3.95713C8.44007 3.74805 9.20745 3.62611 9.9999 3.62611C15.4371 3.62611 19.6942 9.36632 19.8729 9.61074C20.0423 9.84238 20.0423 10.1571 19.8729 10.3889C19.768 10.5324 18.2561 12.5717 15.9246 14.2304L15.0955 13.194C16.7282 12.0423 17.9568 10.6612 18.5006 10.0002C17.4733 8.75402 14.0048 4.94479 9.9999 4.94479Z'
                  fill='#999999'
                />
              </svg>
            ) : (
              <svg
                onClick={() => setActivePass(!activePass)}
                className={"show_pass_icon"}
                width='20'
                height='20'
                viewBox='0 0 20 20'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M19.8729 9.6106C19.6942 9.36619 15.4371 3.62598 9.9999 3.62598C4.56274 3.62598 0.305391 9.36619 0.126914 9.61037C-0.0423048 9.84224 -0.0423048 10.1567 0.126914 10.3886C0.305391 10.633 4.56274 16.3732 9.9999 16.3732C15.4371 16.3732 19.6942 10.633 19.8729 10.3888C20.0423 10.157 20.0423 9.84224 19.8729 9.6106ZM9.9999 15.0546C5.99486 15.0546 2.52606 11.2447 1.49922 9.99916C2.52473 8.75255 5.98626 4.94465 9.9999 4.94465C14.0048 4.94465 17.4733 8.75388 18.5006 10.0001C17.4751 11.2466 14.0135 15.0546 9.9999 15.0546Z'
                  fill='black'
                  fillOpacity='0.4'
                />
                <path
                  d='M9.99902 6.04395C7.8177 6.04395 6.04297 7.81868 6.04297 10C6.04297 12.1813 7.8177 13.9561 9.99902 13.9561C12.1804 13.9561 13.9551 12.1813 13.9551 10C13.9551 7.81868 12.1804 6.04395 9.99902 6.04395ZM9.99902 12.6374C8.54473 12.6374 7.36168 11.4543 7.36168 10C7.36168 8.54575 8.54477 7.36266 9.99902 7.36266C11.4533 7.36266 12.6364 8.54575 12.6364 10C12.6364 11.4543 11.4533 12.6374 9.99902 12.6374Z'
                  fill='black'
                  fillOpacity='0.4'
                />
              </svg>
            )
          ) : (
            <img
              src={showPass}
              className={"show_pass_icon"}
              alt={"show_pass"}
              onClick={() => setActivePass(!activePass)}
            />
          )
        ) : null}
        {props.successInput ? (
          <svg
            className={"show_pass_icon"}
            width='18'
            height='18'
            viewBox='0 0 18 18'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M3.75 9L7.5 12.75L15 5.25'
              stroke='#4BDE97'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        ) : props.wrongInput ? (
          <svg
            className={"show_pass_icon"}
            width='18'
            height='18'
            viewBox='0 0 18 18'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M10.1932 8.99951L13.533 5.65967C13.6916 5.50144 13.7807 5.28672 13.7809 5.06276C13.7811 4.83879 13.6923 4.62392 13.5341 4.46541C13.3759 4.3069 13.1612 4.21774 12.9372 4.21754C12.7132 4.21735 12.4984 4.30613 12.3398 4.46435L9 7.8042L5.66016 4.46435C5.50165 4.30585 5.28666 4.2168 5.0625 4.2168C4.83833 4.2168 4.62335 4.30585 4.46484 4.46435C4.30633 4.62286 4.21729 4.83785 4.21729 5.06201C4.21729 5.28618 4.30633 5.50116 4.46484 5.65967L7.80469 8.99951L4.46484 12.3394C4.30633 12.4979 4.21729 12.7128 4.21729 12.937C4.21729 13.1612 4.30633 13.3762 4.46484 13.5347C4.62335 13.6932 4.83833 13.7822 5.0625 13.7822C5.28666 13.7822 5.50165 13.6932 5.66016 13.5347L9 10.1948L12.3398 13.5347C12.4984 13.6932 12.7133 13.7822 12.9375 13.7822C13.1617 13.7822 13.3766 13.6932 13.5352 13.5347C13.6937 13.3762 13.7827 13.1612 13.7827 12.937C13.7827 12.7128 13.6937 12.4979 13.5352 12.3394L10.1932 8.99951Z'
              fill='#F26464'
            />
          </svg>
        ) : null}
      </label>
      {!props.errMessageHidden ? (
        props.error ? (
          <span
            className={"input_component_error_text"}
            style={{ color: "var(--error)", margin: "8px 0 0", padding: "0" }}
          >
            {props.errTitle ? props.errTitle : "Fill this label"}
          </span>
        ) : null
      ) : null}
    </div>
  );
});

export default TextInput;
